<template>
    <el-input v-bind="$attrs" v-on="inputListeners" :value="value" class="wrap-input" size="small">
        <template #prefix>
            <slot name="prefix"></slot>
        </template>        
        <template #prepend>
            <slot name="prepend"></slot>
        </template>
        <template #append>
            <slot name="append"></slot>
        </template>
        <template #suffix>
            <slot name="suffix">
                <i @click.stop="onClear" v-if="showClear" class="el-icon-close"></i>
            </slot>
        </template>
    </el-input>
</template>
<script>
import { isEmptyStringOrNil } from '@/utils/lang'

export default {
    name: 'wrap-input',
    model: {
        prop: 'value',
        event: 'input',
    },
    props: {
        clearable: {
            type: Boolean,
            default: false,
        },
        IsNumber: {
            type: Boolean,
            default: false,
        },
        IsInteger: {
            type: Boolean,
            default: false,
        },
        OnlyNumber: {
            type: Boolean,
            default: false,
        },
        value: {
        }
    },
    methods: {
        onClear() {
            this.$emit('clear')
        }
    },
    computed: {
        showClear() {
            if (!this.clearable) {
                return false
            }
            if (isEmptyStringOrNil(this.value)) {
                return false
            }
            return true
        },
        inputListeners() {
            let vm = this
            return Object.assign({}, this.$listeners,
                {
                    input(value) {
                        if (vm.IsInteger) {
                            value = value.replace(/[^-\deE]/g, '')
                        } else if (vm.OnlyNumber || vm.IsNumber) {
                            value = value.replace(/[^-\d\.eE]/g, '')
                        }
                        if (vm.IsNumber) {
                            // if (value !== '') {
                            //     value = Number(value)
                            // } else {
                            //     value = null
                            // }
                        }
                        vm.$emit('input', value)
                    },
                })
        },
    },
    mounted() {
        this.$emit('mounted')
    }
}
</script>
<style lang="scss" scoped>
.wrap-input {
    .el-icon-close {
        margin-right: 4px;
    }
}
</style>
